export default "__VITE_ASSET__53a39ab4__"